export default [
    {
    title: 'Отчеты',
    icon: 'FileTextIcon',
    children: [

        {
            title: 'Базовые отчеты',
            route: 'report-base',
            action: 'read',
            resource: 'report',
        },
        {
            title: 'Шаблонизированные отчеты',
            route: 'report-wrapped',
            action: 'read',
            resource: 'wrapper',
        },
    ]
  },
]
